export default __webpack_public_path__ + "static/media/Policies-not.517791ed.svg";